// extracted by mini-css-extract-plugin
export default {"chatTabs":"tm_tn","chatTabs__button":"tm_to","chatTabs__button_active":"tm_tp","chatTabs__iconWrapper":"tm_tq","chatTabs__badge":"tm_tr"};